import { render, staticRenderFns } from "./DocumentNoteModal.vue?vue&type=template&id=25d04b52"
import script from "./DocumentNoteModal.vue?vue&type=script&lang=js"
export * from "./DocumentNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d04b52')) {
      api.createRecord('25d04b52', component.options)
    } else {
      api.reload('25d04b52', component.options)
    }
    module.hot.accept("./DocumentNoteModal.vue?vue&type=template&id=25d04b52", function () {
      api.rerender('25d04b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DocumentNoteModal.vue"
export default component.exports